export const RMA_MANAGER_USER = 'RMA Manager (User)';
export const RMA_MANAGER_MANAGER = 'RMA Manager (Manager)';
export const QUOTE = 'Quote';
